import { scriptLoader } from '../utils/script.utils';

const WIDGET_SCRIPT_URL = 'https://assets.calendly.com/assets/external/widget.js';
const WIDGET_CSS_URL = 'https://assets.calendly.com/assets/external/widget.css';

type PopupWidgetPrefill = {
  firstName?: string;
  lastName?: string;
  email?: string;
};

type PopupWidgetOptions = {
  url: string;
  prefill?: PopupWidgetPrefill;
};

declare global {
  interface Window {
    Calendly?: {
      initPopupWidget: (options: PopupWidgetOptions) => void;
    };
  }
}

let assetsPromise: Promise<void> | null = null;

function loadStyles(): void {
  if (document.querySelector(`link[href="${WIDGET_CSS_URL}"]`)) {
    return;
  }
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = WIDGET_CSS_URL;
  document.head.appendChild(link);
}

function loadCalendlyAssets(): Promise<void> {
  if (!assetsPromise) {
    loadStyles();
    assetsPromise = new Promise((resolve, reject) => {
      scriptLoader(
        WIDGET_SCRIPT_URL,
        () => resolve(),
        (error) => {
          assetsPromise = null;
          reject(error);
        },
      );
    });
  }
  return assetsPromise;
}

export function openCalendlyPopup(url: string, prefill?: PopupWidgetPrefill): void {
  loadCalendlyAssets()
    .then(() => {
      window.Calendly?.initPopupWidget({ url, prefill });
    })
    .catch((error) => {
      throw new Error('Failed to load Calendly widget assets', { cause: error });
    });
}

export function preloadCalendlyAssets(): void {
  loadCalendlyAssets().catch(() => {});
}
